const EVENT_NAME = 'rh:bug-report'

function nowIso() {
  return new Date().toISOString()
}

function getUsuario(store) {
  const usuario = store && store.state && store.state.login
    ? store.state.login.datosUsuarioERP
    : null

  if (!usuario || typeof usuario !== 'object') return {}

  return {
    id_usuario: usuario.id_usuario || usuario.idusuario || null,
    iderp: usuario.iderp || null,
    idpuesto: usuario.idpuesto || usuario.id_puesto || null,
    puesto: usuario.puesto || null,
    rol: usuario.rol || usuario.puesto || null,
    nombre_completo: usuario.nombre_completo || [usuario.nombre_usuario, usuario.apellido_usuario].filter(Boolean).join(' '),
    nombre_usuario: usuario.nombre_usuario || null,
    apellido_usuario: usuario.apellido_usuario || null,
    plantel: usuario.plantel || null,
  }
}

function getModulo(menu, routeName) {
  if (!Array.isArray(menu) || !routeName) return {}

  for (const item of menu) {
    const items = Array.isArray(item.items) ? item.items : []
    for (const cat of items) {
      if (Array.isArray(cat.items)) {
        const child = cat.items.find((el) => el.path === routeName)
        if (child) {
          return {
            menu: item.title,
            submenu: cat.title,
            action: child.title,
            path: child.path,
          }
        }
      } else if (cat.path === routeName) {
        return {
          menu: item.title,
          submenu: null,
          action: cat.title,
          path: cat.path,
        }
      }
    }
  }

  return {}
}

function getRoute(router) {
  const route = router && router.currentRoute ? router.currentRoute : null
  if (!route) return {}
  return {
    name: route.name || null,
    path: route.path || null,
    fullPath: route.fullPath || null,
    params: route.params || {},
    query: route.query || {},
  }
}

export function buildManualBugContext({ store, router }) {
  const route = getRoute(router)
  const menu = store && store.state && store.state.login ? store.state.login.menu : []

  return {
    source: 'manual',
    timestamp: nowIso(),
    usuario: getUsuario(store),
    route,
    modulo: getModulo(menu, route.name),
    request: {},
    error: {},
  }
}

export function notifyBugReporterFromAxios() {
  // Solo reporte manual (botón "Reportar problema"). No POST automático al API.
}

export function notifyBugReporterFromError() {
  // Solo reporte manual (botón "Reportar problema"). No POST automático al API.
}

export { EVENT_NAME as BUG_REPORT_EVENT_NAME }
